export const TRANSPARENT_COLOR = 'transparent' as const;
